import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './PermissionGuard.css';

const PermissionGuard = ({ 
  children, 
  requiredRoles = [], 
  requiredPermissions = [],
  requiredModule = null,
  fallback = null 
}) => {
  const { hasRole, hasPermission, hasModuleAccess } = useAuth();
  const navigate = useNavigate();

  // Vérifier l'accès au module (priorité la plus haute pour le système de permissions par module)
  if (requiredModule) {
    if (!hasModuleAccess(requiredModule)) {
      if (fallback) {
        return <>{fallback}</>;
      }
      return (
        <div className="permission-denied">
          <div className="permission-denied-content">
            <h2>Accès refusé</h2>
            <p>Vous n'avez pas les permissions nécessaires pour accéder à cette page.</p>
            <p>Module requis: {requiredModule}</p>
            <button onClick={() => navigate('/')} className="btn btn-primary">
              Retour à l'accueil
            </button>
          </div>
        </div>
      );
    }
    // Si l'accès au module est vérifié, on autorise l'accès (pas besoin de vérifier les rôles)
    return <>{children}</>;
  }

  // Vérifier les rôles (fallback si requiredModule n'est pas spécifié)
  if (requiredRoles.length > 0) {
    const hasRequiredRole = requiredRoles.some(role => hasRole(role));
    if (!hasRequiredRole) {
      if (fallback) {
        return <>{fallback}</>;
      }
      return (
        <div className="permission-denied">
          <div className="permission-denied-content">
            <h2>Accès refusé</h2>
            <p>Vous n'avez pas les permissions nécessaires pour accéder à cette page.</p>
            <p>Rôles requis: {requiredRoles.join(', ')}</p>
            <button onClick={() => navigate('/')} className="btn btn-primary">
              Retour à l'accueil
            </button>
          </div>
        </div>
      );
    }
  }

  // Vérifier les permissions
  if (requiredPermissions.length > 0) {
    const hasRequiredPermission = requiredPermissions.some(permission => hasPermission(permission));
    if (!hasRequiredPermission) {
      if (fallback) {
        return <>{fallback}</>;
      }
      return (
        <div className="permission-denied">
          <div className="permission-denied-content">
            <h2>Accès refusé</h2>
            <p>Vous n'avez pas les permissions nécessaires pour accéder à cette ressource.</p>
            <button onClick={() => navigate('/')} className="btn btn-primary">
              Retour à l'accueil
            </button>
          </div>
        </div>
      );
    }
  }

  return <>{children}</>;
};

export default PermissionGuard;

